import { render, staticRenderFns } from "./RenderCargaDanfe.vue?vue&type=template&id=60fa5707&scoped=true"
import script from "./RenderCargaDanfe.vue?vue&type=script&lang=ts"
export * from "./RenderCargaDanfe.vue?vue&type=script&lang=ts"
import style0 from "./RenderCargaDanfe.vue?vue&type=style&index=0&id=60fa5707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa5707",
  null
  
)

export default component.exports